import React from 'react'

export default function ExportReport() {
  return (
    <div>
      <h2>Xuất báo cáo</h2>
    </div>
  )
}
